export default __webpack_public_path__ + "static/media/isp.ffd7d3c6.svg";